import { LegoSize } from './LegoTypes';

/**
 * Placas cuadradas disponibles en Pick a Brick (categoría Plates).
 * Cada tamaño S/M/L del generador usa una placa N×N que cubre un "píxel" del patrón.
 *
 * @see https://www.lego.com/es-es/pick-and-build/pick-a-brick (filtrar Placas)
 */
export const PAB_SQUARE_PLATES = {
  1: { designId: '3024', name: 'Plate 1 x 1' },
  2: { designId: '3022', name: 'Plate 2 x 2' },
  3: { designId: '11212', name: 'Plate 3 x 3' },
} as const;

export type PabPlateStudSize = keyof typeof PAB_SQUARE_PLATES;

export const PAB_PLATE_STUD_SIZES = Object.keys(PAB_SQUARE_PLATES).map(
  Number,
) as PabPlateStudSize[];

/** Tamaño en studs de la placa cuadrada para cada tamaño de letra del generador. */
export const PLATE_STUD_SIZE_BY_LEGO_SIZE: Record<LegoSize, PabPlateStudSize> = {
  S: 1,
  M: 2,
  L: 3,
};

export function getPlateStudSize(size: LegoSize): PabPlateStudSize {
  return PLATE_STUD_SIZE_BY_LEGO_SIZE[size];
}

export function isPabSquarePlateSize(studs: number): studs is PabPlateStudSize {
  return studs in PAB_SQUARE_PLATES;
}

export function buildPlateInventoryKey(studs: PabPlateStudSize, color: string): string {
  return `${studs}x${studs} ${color} plate`;
}
